<script setup>
import { ref, computed, defineProps } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
})

const activeIndex = ref(0)

function selectTab(index) {
  activeIndex.value = index
}

const currentTab = computed(() => props.tabs[activeIndex.value])

</script>

<template>
    <div class="relative w-full h-screen pb-[80px] overflow-x-hidden bg-zinc-100 dark:bg-zinc-800">
        <!-- Contenido dinámico -->
        <component :is="currentTab.component" />
    </div>
    <div class="tabbar">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          @click="selectTab(index)"
          :class="{ active: index === activeIndex }"
          :disabled="!tab.component"
        >
          <component :is="tab.icon"/>
        </button>
    </div>
</template>

<style scoped>
  /*
  **TABBAR
  */
  .tabbar {
      @apply w-full fixed bg-white dark:bg-zinc-700 left-0 bottom-0 z-10 flex justify-around pb-3;
  }

  .tabbar::before {
      @apply absolute content-[""] left-0 top-[-16px] w-[50%] h-[62px] bg-white dark:bg-zinc-700 z-[-1] rounded-tr-[62px] border-t border-zinc-200/50 dark:border-zinc-900/50;
    
  }

  .tabbar::after {
      @apply absolute content-[""] right-0 top-[-16px] w-[50%] h-[62px] bg-white dark:bg-zinc-700 z-[-1] rounded-tl-[62px] border-t border-zinc-200/50 dark:border-zinc-900/50;
  }

  .tabbar button {
      @apply bg-no-repeat bg-center bg-contain relative block;
  }

  .tabbar button.active svg {
      @apply fill-[var(--color)]
  }
</style>